<template>
  <b-breadcrumb class="breadCrumb">
    <b-breadcrumb-item>
      <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
      <router-link :to="{name: 'manager_dashboard'}">ホーム </router-link>
    </b-breadcrumb-item>
    <b-breadcrumb-item @click="backFile"> ファイル一覧</b-breadcrumb-item>
    <b-breadcrumb-item class="active"> ファイル詳細</b-breadcrumb-item>
  </b-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      show: false
    }
  },
  methods: {
    backFile () {
      if (this.$route.query.parent !== 'search') {
        this.$router.push(`/manager/items/${this.$route.query.parent}`)
      } else {
        this.$router.push(`/manager/items/0`)
      }
    }
  },
  props: {
    active: ''
  },
  computed: {

  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/auth/breadcrumb.scss";
</style>



// WEBPACK FOOTER //
// src/views/Manager/FolderManager/Breadcrumb.vue